var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { classNames } from "@bookingcom/bui-core/utilities/classNames";
import CheckmarkFillIcon from "@bookingcom/bui-assets-react/streamline/CheckmarkFillIcon";
import FormControl from "../FormControl/index.js";
import Text from "../Text/index.js";
import Icon from "../Icon/index.js";
import Stack from "../Stack/index.js";
import useIsomorphicLayoutEffect from "../../hooks/useIsomorphicLayoutEffect.js";
import useComposeRefs from "../../hooks/useComposeRefs.js";
import useId from "../../hooks/useId.js";
import { useInputCheckboxGroup } from "../InputCheckboxGroup/index.js";
import styles from "@bookingcom/bui-core/css/InputCheckbox.module.css";
var InputCheckbox = function (props) {
    var _a;
    var error = props.error, label = props.label, helper = props.helper, className = props.className, onChange = props.onChange, onFocus = props.onFocus, onBlur = props.onBlur, attributes = props.attributes, value = props.value, indeterminate = props.indeterminate, inputAttributes = props.inputAttributes, children = props.children, icon = props.icon, mixin = props.mixin;
    var checkboxGroup = useInputCheckboxGroup();
    var name = (checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.name) || props.name;
    var disabled = (checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.disabled) || props.disabled;
    var checked = checkboxGroup
        ? (_a = checkboxGroup.value) === null || _a === void 0 ? void 0 : _a.includes(value)
        : props.checked;
    var defaultChecked = checkboxGroup ? undefined : props.defaultChecked;
    var internalRef = React.useRef(null);
    var syncRefs = useComposeRefs(internalRef, inputAttributes === null || inputAttributes === void 0 ? void 0 : inputAttributes.ref);
    var id = useId(props.id);
    var rootClassName = classNames(styles.root, className, (!!error || !!(checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.error)) && styles["root--error"]);
    var handleChange = function (event) {
        var checked = event.target.checked;
        if (!name) {
            // eslint-disable-next-line no-console
            console.error("[BUI:InputCheckbox] Missing name property");
            return;
        }
        if (checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.onItemChange) {
            checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.onItemChange({ name: name, value: value, checked: checked, event: event });
        }
        else {
            onChange === null || onChange === void 0 ? void 0 : onChange({ name: name, value: value, checked: checked, event: event });
        }
    };
    useIsomorphicLayoutEffect(function () {
        internalRef.current.indeterminate = indeterminate || false;
    }, [indeterminate]);
    return (React.createElement(React.Fragment, null,
        React.createElement(FormControl, { id: id, error: error, disabled: disabled, className: rootClassName, attributes: attributes, mixin: mixin }, function (controlAttributes) { return (React.createElement(React.Fragment, null,
            React.createElement("input", __assign({}, inputAttributes, controlAttributes, { className: styles.input, type: "checkbox", name: name, disabled: disabled, checked: checked === null ? false : checked, defaultChecked: defaultChecked, value: value, onFocus: onFocus || (inputAttributes === null || inputAttributes === void 0 ? void 0 : inputAttributes.onFocus), onBlur: onBlur || (inputAttributes === null || inputAttributes === void 0 ? void 0 : inputAttributes.onBlur), onChange: handleChange, ref: syncRefs })),
            React.createElement(Stack, { direction: "row", tagName: "label", className: styles.container, attributes: { htmlFor: controlAttributes.id } },
                React.createElement("span", { className: styles.hitbox }),
                React.createElement("span", { className: styles.field },
                    React.createElement(Icon, { svg: CheckmarkFillIcon, className: styles["checkbox-icon"] })),
                icon && (React.createElement("span", { className: styles.icon },
                    React.createElement(Icon, { svg: icon, size: "small" }))),
                (label || helper) && (React.createElement(Stack.Item, { tagName: "span", grow: true },
                    label && (React.createElement(Text, { color: disabled ? "disabled" : "neutral", className: styles.label }, label)),
                    helper && (React.createElement(Text, { variant: "small_1", color: disabled ? "disabled" : "neutral_alt", className: styles.helper }, helper))))))); }),
        children && React.createElement("div", { className: styles.bottom }, children)));
};
export default InputCheckbox;
